import { useContext } from 'react';
import { RouteComponentProps, StaticContext } from 'react-router';
import * as History from 'history';
import { RouterContext } from './RouterContext';

export function useRouter<
  Params extends { [K in keyof Params]?: string } = {},
  C extends StaticContext = StaticContext,
  S = History.LocationState,
  QueryParams = {}
>() {
  return useContext(RouterContext) as RouteComponentProps<Params, C, S> & {
    query: QueryParams;
    isActive: (route: string) => boolean;
  };
}
